var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "vial@1x-a",
          d:
            "M20.1 12.9L20.2001 11.7C20.2001 10.8 19.5001 10.1 18.7001 9.99999L17.5 9.89999C16.9 9.79999 16.4 9.79999 15.8 9.79999V7.89999C15.8 7.79999 15.9 7.59999 16.1 7.59999H16.6V6.49999H16C15.2 6.49999 14.7 7.09999 14.7 7.79999V9.69999H13.7L13 5.89999H13.7V4.89999H8.40005C7.20005 4.89999 6.20005 5.79999 6.00005 6.89999L5.50005 9.29999H3.50005V10.4H5.30005L5.20005 11.1C3.50005 11.7 2.30005 13.3 2.30005 15C2.30005 17.3 4.20005 19.1 6.40005 19.1C8.00005 19.1 9.50005 18.1 10.2 16.7H15.3C15.8 18.1 17 19.1 18.5 19.1C20.4 19.1 21.8 17.6 21.8 15.8C21.7 14.6 21.2 13.6 20.1 12.9ZM18.4 12.5C16.6 12.5 15.1 13.9 15.1 15.7H13.8V10.8H15.5C16.1 10.8 16.8 10.8 17.4 10.9L18.6 11C19 11.1 19.2001 11.4 19.2001 11.7V12.6C18.8001 12.5 18.6 12.5 18.4 12.5ZM18.4 13.5C19.6 13.5 20.7001 14.5 20.7001 15.8C20.7001 17.1 19.7 18.1 18.4 18.1C17.2 18.1 16.1 17.1 16.1 15.8C16.1 14.6 17.2 13.5 18.4 13.5ZM12.7 15.1V15.6H12.2V15.1H12.7ZM12.7 13.5V14H12.2V13.5H12.7ZM9.50005 15C9.50005 16.7 8.10005 18.1 6.40005 18.1C4.70005 18.1 3.30005 16.8 3.30005 15C3.30005 13.2 4.60005 11.9 6.40005 11.9C8.20005 11.9 9.50005 13.3 9.50005 15ZM12.7 10.2V12.4H11.6C11 11.2 10.1 10.4 9.00005 9.79999V5.89999H12L12.7 10.2ZM6.40005 10.9H6.30005L6.40005 10.4H6.50005C8.40005 10.4 10.1 11.5 10.9 13.3L11 13.6H11.2V15.7H10.6C10.7 15.5 10.7 15.3 10.7 15C10.5 12.7 8.60005 10.9 6.40005 10.9ZM7.90005 5.99999V9.39999C7.40005 9.29999 7.00005 9.29999 6.60005 9.29999L7.00005 7.19999C7.10005 6.59999 7.40005 6.19999 7.90005 5.99999Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "xlink:href": "#vial@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }